<template>
    <component :is="element" @click="$emit('click', $event)">
        <slot />
    </component>
</template>

<script>
    export default {
        name: 'app-button',
        props: {
            element: {
                type: String,
                required: true
            }
        }
    }
</script>

<style lang="scss">
    .btn {
        @apply .inline-block .align-middle .cursor-pointer .border-0;

        &:hover {
            @apply .no-underline;
        }
    }
    /**
    * Set Types
    */
    .btn {
        /**
        * Button -> Primary
        */
        &--primary, &--secondary, &--tertiary {
            @apply .p-4 .bg-blue .text-base .text-white .text-center .rounded-lg;
  
            transition: background 0.2s ease-in-out, color 0.2s ease-in-out;

            &:hover,
            &:focus,
            &.active {
                @apply .bg-blue-dark;
            }

            &.disabled {
                @apply .bg-grey;
            }

            &--full {
                @apply .block .w-full;
            }

            &--sml {
                @apply .px-4 .py-2;
            }
            &--med {
                @apply .px-6 .py-3;
            }
        }

        &--secondary {
            @apply .bg-orange;

            &:hover,
            &:focus,
            &.active {
                @apply .bg-orange-dark;
            }
        }

        &--tertiary {
            @apply .bg-grey-lighter .text-black;

            &:hover,
            &:focus,
            &.active {
                @apply .bg-blue .text-white;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Button.vue